import css from "styled-jsx/css";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";


export const componentStyles = css.global`
  .monday-integrations-connections-component {
    max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH + "px"};
    height: 1070px;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    

    .monday-integrations-wrapper {
      padding-top: 100px;
      position: relative;
      display: flex;
      flex-direction: column;
      .title-wrapper{
        padding-bottom: 50px;
        text-align: center;
      }
      .switch-wrapper {
        display: flex;
        justify-content: center;
      }
      .before-animation-paragraph-wrapper{
        text-align: center;
        padding-top: 30px;
        padding-botton: 20px;
      }
      .after-animation-paragraph-wrapper{
        display: none;
        text-align: center;
        padding-top: 30px;
        padding-botton: 20px;
      }
      

      .icons-and-lines-wrapper{
      position: relative;
      .monday-logo {
        position: absolute;
        left: var(--left);
        top: var(--top);
        opacity: 0;
        transition: opacity 1s;
        .picture-component{
          img{
            max-height: 340px;
          }
        }
      }
      .icon {
        position: absolute;
        top: var(--y-before);
        left: var(--x-before);
        transition: top 1s, left 1s;
      }
      .line {
        transition: opacity 1s;
      }
      .paths{
        display:none;
      }
    }
      &.animation {
        
        .before-animation-paragraph-wrapper{
          display:none;
        }
        .after-animation-paragraph-wrapper{
          display: unset;
        }
        .icons-and-lines-wrapper{
          .monday-logo {
            opacity: 1;
          }
        .icon {
          top: var(--y-after);
          left: var(--x-after);
        }
        .line {
          opacity: 0;
          display:none;
        }
        .paths{
          display:unset;
        }
      }
      }
    }
  }
`;
